import { useConnect } from '@lore/query-connect';
import { event_networkId } from '../../../../utils/query-helpers';

export default function useEducatorEventEvaluationsCreated(network, timestamp) {
  return useConnect('evaluationEventEducator.find', {
    where: {
      eager: {
        $where: {
          ...event_networkId(network),
          createdAt: {
            $gte: timestamp.start,
            $lte: timestamp.end
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
